import { TFunction } from 'react-i18next';
import { BidStatusEnum } from '@/models/bidding.model';

export const getStatusLabel = (t: TFunction, status: BidStatusEnum, ownerName?: string) => {
  switch (status) {
    case BidStatusEnum.EXPIRED:
      return t('bidding_bid_expired');
    case BidStatusEnum.ACCEPTED:
      if (ownerName) {
        return t('bid_status_accepted_owner', { owner: ownerName });
      }
      return t('bidding_you_accepted_this_bid');
    case BidStatusEnum.REJECTED:
      if (ownerName) {
        return t('bid_status_rejected_owner', { owner: ownerName });
      }
      return t('bid_status_rejected');
    case BidStatusEnum.WAITING_CONFIRMATION:
      return t('bid_status_waiting_confirmation');
    case BidStatusEnum.CONFIRMED:
      return t('bid_status_standing');
    default:
      return null;
  }
};
